import React, { useState } from 'react';
import '../styles/themes.css';
import { Building2, ArrowRight, Star, Phone, Menu, Quote, MapPin } from 'lucide-react';

/* ---- Design themes (from design_guidelines.md) ---- */
const THEMES = [
  { id: 'classic', name: 'Klasik', desc: 'Nötr, güvenli, her sektöre uyan varsayılan görünüm.', fonts: 'Space Grotesk + IBM Plex Sans',
    heroTitle: 'İşinizi Bir Adım Öne Taşıyın', heroSub: 'Güvenilir çözümler ve profesyonel hizmet anlayışıyla yanınızdayız.', cta1: 'Keşfet', cta2: 'İletişim' },
  { id: 'atlas', name: 'Atlas', desc: 'İnşaat/mimarlık: güçlü grid, keskin köşeler, teknik güven.', fonts: 'Montserrat + IBM Plex Sans',
    heroTitle: 'Güçlü Temeller, Kusursuz Projeler', heroSub: 'Mühendislik disiplini ve zamanında teslim garantisiyle inşa ediyoruz.', cta1: 'Projelerimiz', cta2: 'Teklif Al' },
  { id: 'luna', name: 'Luna', desc: 'Otel/lüks: yumuşak, büyük radius, sakin yüzeyler.', fonts: 'Playfair Display + Figtree',
    heroTitle: 'Unutulmaz Bir Konaklama Deneyimi', heroSub: 'Zarafet ve konforun buluştuğu eşsiz anlar sizi bekliyor.', cta1: 'Odaları Gör', cta2: 'Rezervasyon' },
  { id: 'bistro', name: 'Bistro', desc: 'Restoran/kafe: sıcak, editorial tipografi, etiket dili.', fonts: 'Crimson Text + Montserrat',
    heroTitle: 'Her Lokmada Taze Lezzet', heroSub: 'Günlük taze malzemeler ve sıcak bir atmosferle hizmetinizdeyiz.', cta1: 'Menüyü Gör', cta2: 'Masa Ayırt' },
  { id: 'clinic', name: 'Klinik', desc: 'Sağlık: steril, yüksek okunabilirlik, güven veren.', fonts: 'Figtree + Source Serif',
    heroTitle: 'Sağlığınız Güvenli Ellerde', heroSub: 'Uzman kadromuz ve modern tedavi yöntemlerimizle yanınızdayız.', cta1: 'Randevu Al', cta2: 'Bölümler' },
  { id: 'studio', name: 'Stüdyo', desc: 'Ajans/yaratıcı: editorial, cesur boşluk, büyük tipografi.', fonts: 'Space Grotesk + Crimson Text',
    heroTitle: 'Markanızı Yeniden Hayal Edin', heroSub: 'Yaratıcı fikirleri ölçülebilir sonuçlara dönüştürüyoruz.', cta1: 'Çalışmalarımız', cta2: 'İletişime Geç' },
  { id: 'mono', name: 'Monokrom', desc: 'Teknoloji/B2B: disiplinli, yüksek kontrast, mono detay.', fonts: 'Roboto Mono + Figtree',
    heroTitle: 'Ölçeklenebilir Dijital Çözümler', heroSub: 'İşinizi büyüten güvenli ve hızlı teknoloji altyapısı.', cta1: 'Ürünü İncele', cta2: 'Demo İste' },
  { id: 'play', name: 'Neşeli', desc: 'Eğitim/çocuk/etkinlik: yuvarlak, sıcak, büyük butonlar.', fonts: 'Fredoka + Figtree',
    heroTitle: 'Öğrenmek Hiç Bu Kadar Eğlenceli Olmadı', heroSub: 'Çocuklar için güvenli, renkli ve keyifli bir öğrenme ortamı.', cta1: 'Programlar', cta2: 'Hemen Katıl' },
  { id: 'civic', name: 'Sivil', desc: 'Dernek/vakıf/STK: güven veren, sade, insani.', fonts: 'IBM Plex Sans + Source Serif',
    heroTitle: 'Birlikte Daha Güçlüyüz', heroSub: 'Dayanışmayı büyütüyor, toplumumuza değer katıyoruz.', cta1: 'Üye Ol', cta2: 'Bize Katılın' },
  { id: 'verdict', name: 'Hüküm', desc: 'Hukuk/finans: otoriter, belge hissi, ciddi.', fonts: 'Playfair Display + IBM Plex Sans',
    heroTitle: 'Haklarınızı Güvenle Savunuyoruz', heroSub: 'Deneyimli hukuk kadromuzla her zaman yanınızdayız.', cta1: 'Hizmetler', cta2: 'Danışmanlık Al' },
  { id: 'estate', name: 'Emlak', desc: 'Gayrimenkul: premium broşür, ferah, görsel odaklı.', fonts: 'Montserrat + Source Serif',
    heroTitle: 'Hayalinizdeki Eve Bir Adım', heroSub: 'Size en uygun gayrimenkul fırsatlarını birlikte keşfedelim.', cta1: 'İlanları Gör', cta2: 'Bize Ulaşın' },
  { id: 'atelier', name: 'Atölye', desc: 'Güzellik/kozmetik: zarif, ince, editorial.', fonts: 'Crimson Text + Figtree',
    heroTitle: 'Güzelliğinizi Ortaya Çıkarın', heroSub: 'Uzman dokunuşlarla kendinizi yenileyin ve ışıldayın.', cta1: 'Hizmetler', cta2: 'Randevu Al' },
  { id: 'pulse', name: 'Nabız', desc: 'Spor/fitness: enerjik, sıkı, performans odaklı.', fonts: 'Space Grotesk + Roboto Mono',
    heroTitle: 'Sınırlarını Yeniden Belirle', heroSub: 'Hedeflerine ulaşman için enerji dolu bir antrenman programı.', cta1: 'Üyelik Al', cta2: 'Dersleri Gör' },
  { id: 'retail', name: 'Perakende', desc: 'E-ticaret: temiz, hızlı taranabilir, ürün odaklı.', fonts: 'Figtree + IBM Plex Sans',
    heroTitle: 'Aradığınız Her Şey Tek Tıkla', heroSub: 'Binlerce ürün, hızlı teslimat ve güvenli alışveriş deneyimi.', cta1: 'Alışverişe Başla', cta2: 'Kampanyalar' },
  { id: 'gazette', name: 'Gazete', desc: 'Moda/editorial: dergi ritmi, güçlü tipografi.', fonts: 'Playfair Display + Crimson Text',
    heroTitle: 'Sezonun Trendlerini Keşfedin', heroSub: 'Stilinizi tanımlayan özenle seçilmiş koleksiyonlar.', cta1: 'Koleksiyon', cta2: 'Daha Fazla' },
  { id: 'gallery', name: 'Galeri', desc: 'Sanat/portfolyo: sessiz, boşluklu, sergi hissi.', fonts: 'Source Serif + Figtree',
    heroTitle: 'Her Eser Kendi Hikayesini Anlatır', heroSub: 'Özenle kürate edilmiş bir sergi deneyimine davetlisiniz.', cta1: 'Galeriyi Gez', cta2: 'Sanatçılar' },
];

const PALETTES = [
  { name: 'Altın', accent: '#d4950a' },
  { name: 'Okyanus', accent: '#0ea5e9' },
  { name: 'Zümrüt', accent: '#10b981' },
  { name: 'Bordo', accent: '#dc2626' },
  { name: 'Mor', accent: '#8b5cf6' },
  { name: 'Turuncu', accent: '#f97316' },
  { name: 'Pembe', accent: '#ec4899' },
  { name: 'Lacivert', accent: '#3b82f6' },
  { name: 'Turkuaz', accent: '#14b8a6' },
  { name: 'Şarap', accent: '#be123c' },
];

const HEROES = [
  { v: 'v1', label: 'V1 Standart' },
  { v: 'v2', label: 'V2 Tam Ekran' },
  { v: 'v3', label: 'V3 Bölünmüş' },
  { v: 'v4', label: 'V4 Karanlık Minimal' },
  { v: 'v5', label: 'V5 Kart Grid' },
  { v: 'v6', label: 'V6 Galeri Şeridi' },
];

function hexToHSL(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      default: h = ((r - g) / d + 4) / 6; break;
    }
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/* ---- Sample primitives (consume design tokens) ---- */
const btnBase = 'inline-flex items-center justify-center gap-1.5 text-sm transition-[transform,box-shadow,background-color] duration-200 active:scale-[0.98]';
const btnStyle = { borderRadius: 'var(--btn-radius)', paddingLeft: 'var(--btn-px)', paddingRight: 'var(--btn-px)', paddingTop: 'var(--btn-py)', paddingBottom: 'var(--btn-py)', fontWeight: 'var(--btn-weight)' };

const PrimaryBtn = ({ children }) => (
  <button className={`${btnBase} hover:-translate-y-px`}
    style={{ ...btnStyle, background: 'hsl(var(--accent))', color: 'hsl(var(--accent-foreground))', boxShadow: 'var(--btn-shadow)' }}
    data-testid="sample-primary-btn">{children}</button>
);
const SecondaryBtn = ({ children }) => (
  <button className={`${btnBase} hover:bg-[hsl(var(--accent)/0.08)]`}
    style={{ ...btnStyle, border: '1.5px solid hsl(var(--accent))', color: 'hsl(var(--accent))' }}
    data-testid="sample-secondary-btn">{children}</button>
);
const GhostBtn = ({ children }) => (
  <button className={`${btnBase} underline-offset-4 hover:underline`} style={{ ...btnStyle, color: 'hsl(var(--foreground))' }}>{children}</button>
);

const SampleCard = ({ title, text }) => (
  <div className="dt-body overflow-hidden" style={{ borderRadius: 'var(--card-radius)', borderWidth: 'var(--card-border-width)', borderStyle: 'solid', borderColor: 'hsl(var(--border))', boxShadow: 'var(--card-shadow)', background: 'hsl(var(--card))' }}>
    <div className="h-24 flex items-center justify-center" style={{ background: 'hsl(var(--accent)/0.12)' }}>
      <Building2 className="w-8 h-8" style={{ color: 'hsl(var(--accent))' }} />
    </div>
    <div style={{ padding: 'var(--card-padding)' }}>
      <h4 className="dt-heading font-semibold text-sm mb-1" style={{ color: 'hsl(var(--card-foreground))' }}>{title}</h4>
      <p className="text-xs mb-2" style={{ color: 'hsl(var(--muted-foreground))' }}>{text}</p>
      <span className="inline-flex items-center gap-1 text-xs font-medium" style={{ color: 'hsl(var(--accent))' }}>Detay <ArrowRight className="w-3 h-3" /></span>
    </div>
  </div>
);

function MiniNavbar() {
  return (
    <div className="flex items-center justify-between px-4 py-3 mb-4"
      style={{ borderRadius: 'var(--navbar-radius)', borderBottom: 'var(--navbar-border) solid hsl(var(--border))', background: 'hsl(var(--card)/0.9)', backdropFilter: 'blur(var(--navbar-backdrop))' }}>
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center" style={{ background: 'hsl(var(--accent))', borderRadius: 'var(--btn-radius)' }}>
          <Building2 className="w-4 h-4" style={{ color: 'hsl(var(--accent-foreground))' }} />
        </div>
        <span className="dt-heading font-semibold text-sm" style={{ color: 'hsl(var(--foreground))' }}>Firma Adı</span>
      </div>
      <div className="hidden sm:flex items-center gap-4 text-xs" style={{ color: 'hsl(var(--muted-foreground))' }}>
        <span>Kurumsal</span><span>Hizmetler</span><span>İletişim</span>
      </div>
      <PrimaryBtn>İletişim</PrimaryBtn>
      <Menu className="w-5 h-5 sm:hidden" style={{ color: 'hsl(var(--foreground))' }} />
    </div>
  );
}

function MiniHero({ ver, theme }) {
  const t = theme || {};
  const titleText = t.heroTitle || 'Hayalinizdeki Projeyi Birlikte Gerçekleştirelim';
  const subText = t.heroSub || 'Profesyonel ekibimizle kaliteli ve güvenilir çözümler sunuyoruz.';
  const c1 = t.cta1 || 'Keşfet';
  const c2 = t.cta2 || 'Daha Fazla';
  const Title = ({ className = '' }) => <h1 className={`dt-heading font-bold ${className}`} style={{ color: 'inherit' }}>{titleText}</h1>;
  const Sub = () => <p className="dt-body text-sm opacity-80 mt-2">{subText}</p>;
  const ctas = <div className="flex flex-wrap gap-2 mt-4"><PrimaryBtn>{c1}</PrimaryBtn><SecondaryBtn>{c2}</SecondaryBtn></div>;
  const img = <div className="w-full h-full flex items-center justify-center" style={{ background: 'hsl(var(--accent)/0.15)' }}><Building2 className="w-10 h-10" style={{ color: 'hsl(var(--accent))' }} /></div>;

  if (ver === 'v3') return (
    <div className="grid grid-cols-2 gap-4 items-center" style={{ color: 'hsl(var(--foreground))' }}>
      <div><Title className="text-xl" /><Sub />{ctas}</div>
      <div className="h-36 overflow-hidden" style={{ borderRadius: 'var(--card-radius)' }}>{img}</div>
    </div>
  );
  if (ver === 'v4') return (
    <div className="dark p-6 text-center" style={{ borderRadius: 'var(--card-radius)', background: 'hsl(222 20% 8%)', color: '#fff' }}>
      <Title className="text-2xl" /><Sub />
      <div className="flex justify-center">{ctas}</div>
    </div>
  );
  if (ver === 'v5') return (
    <div style={{ color: 'hsl(var(--foreground))' }}>
      <Title className="text-lg" /><Sub />
      <div className="grid grid-cols-3 gap-2 mt-3">
        {[0, 1, 2].map(i => <div key={i} className="h-16" style={{ borderRadius: 'var(--card-radius)', background: 'hsl(var(--accent)/0.14)' }} />)}
      </div>
    </div>
  );
  if (ver === 'v6') return (
    <div style={{ color: 'hsl(var(--foreground))' }}>
      <div className="h-28 overflow-hidden mb-2" style={{ borderRadius: 'var(--card-radius)' }}>{img}</div>
      <div className="flex gap-2">{[0, 1, 2, 3].map(i => <div key={i} className="h-10 flex-1" style={{ borderRadius: 'calc(var(--card-radius)/1.5)', background: 'hsl(var(--accent)/0.12)' }} />)}</div>
      <Title className="text-base mt-3" />
    </div>
  );
  // v1 / v2
  const tall = ver === 'v2';
  return (
    <div className={`relative overflow-hidden flex items-end ${tall ? 'h-52' : 'h-40'}`} style={{ borderRadius: 'var(--card-radius)', background: 'hsl(var(--accent)/0.12)' }}>
      <div className="absolute inset-0 flex items-center justify-center opacity-30"><Building2 className="w-16 h-16" style={{ color: 'hsl(var(--accent))' }} /></div>
      <div className={`relative p-5 ${tall ? 'text-center w-full' : ''}`} style={{ color: 'hsl(var(--foreground))' }}>
        <Title className={tall ? 'text-2xl' : 'text-xl'} /><Sub />
        <div className={tall ? 'flex justify-center' : ''}>{ctas}</div>
      </div>
    </div>
  );
}

function ThemeCard({ theme, palette, mode, hero, onApply }) {
  const accentHSL = hexToHSL(palette.accent);
  const style = {
    '--accent': accentHSL,
    '--gold': accentHSL,
    '--ring': accentHSL,
    '--accent-foreground': '0 0% 100%',
    background: 'hsl(var(--background))',
    color: 'hsl(var(--foreground))',
  };
  return (
    <div className="rounded-2xl border border-border overflow-hidden bg-card shadow-[var(--shadow-elev-1)]" data-testid={`theme-preview-card-${theme.id}`}>
      {/* Card header (admin chrome, not themed) */}
      <div className="flex items-start justify-between gap-3 p-4 border-b border-border bg-secondary/40">
        <div>
          <div className="font-heading font-semibold text-sm">{theme.name}</div>
          <p className="text-[11px] text-muted-foreground mt-0.5 max-w-xs">{theme.desc}</p>
          <p className="text-[10px] text-muted-foreground mt-1 font-mono">{theme.fonts}</p>
        </div>
        <button onClick={() => onApply(theme)} data-testid={`theme-preview-apply-theme-${theme.id}`}
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-xs font-medium hover:opacity-90 transition-opacity">
          Bu Temayı Seç
        </button>
      </div>

      {/* Themed preview surface */}
      <div data-design-theme={theme.id} className={mode === 'dark' ? 'dark dt-surface-dark' : 'dt-surface-light'} style={style}>
        <div className="p-4" style={{ gap: 'var(--grid-gap)' }}>
          <MiniNavbar />
          <MiniHero ver={hero} theme={theme} />

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 mt-4" style={{ gap: 'var(--grid-gap)' }}>
            <SampleCard title="Hizmet Bir" text="Kısa açıklama metni buraya gelir." />
            <SampleCard title="Hizmet İki" text="Kısa açıklama metni buraya gelir." />
            <SampleCard title="Hizmet Üç" text="Kısa açıklama metni buraya gelir." />
          </div>

          {/* Buttons */}
          <div className="flex flex-wrap items-center gap-3 mt-4">
            <PrimaryBtn>Birincil</PrimaryBtn>
            <SecondaryBtn>İkincil</SecondaryBtn>
            <GhostBtn>Bağlantı</GhostBtn>
          </div>

          {/* Typography specimen */}
          <div className="mt-5 pt-4 border-t" style={{ borderColor: 'hsl(var(--border))' }}>
            <div className="dt-heading text-2xl font-bold" style={{ color: 'hsl(var(--foreground))' }}>Başlık H1 — Aa Bb Çç</div>
            <div className="dt-heading text-base font-semibold mt-1" style={{ color: 'hsl(var(--foreground))' }}>Alt Başlık H2</div>
            <p className="dt-body text-sm mt-1" style={{ color: 'hsl(var(--muted-foreground))' }}>Gövde metni: Hızlı kahverengi tilki tembel köpeğin üzerinden atladı. 0123456789</p>
            <p className="dt-body text-xs mt-1" style={{ color: 'hsl(var(--muted-foreground))' }}>Küçük metin / açıklama satırı</p>
          </div>

          {/* Testimonial */}
          <div className="mt-4 p-4" style={{ borderRadius: 'var(--card-radius)', background: 'hsl(var(--accent)/0.07)', border: '1px solid hsl(var(--border))' }}>
            <Quote className="w-5 h-5 mb-1" style={{ color: 'hsl(var(--accent))' }} />
            <p className="dt-body text-sm" style={{ color: 'hsl(var(--foreground))' }}>“Ekiple çalışmak harikaydı, sonuçtan çok memnunuz.”</p>
            <div className="flex items-center gap-2 mt-2">
              <div className="w-7 h-7 rounded-full" style={{ background: 'hsl(var(--accent)/0.3)' }} />
              <div className="text-xs"><div className="dt-heading font-semibold" style={{ color: 'hsl(var(--foreground))' }}>Ayşe K.</div><div className="flex gap-0.5">{[0,1,2,3,4].map(i=><Star key={i} className="w-3 h-3 fill-current" style={{ color: 'hsl(var(--accent))' }} />)}</div></div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-4 pt-3 flex items-center justify-between text-[11px]" style={{ borderTop: '1px solid hsl(var(--border))', color: 'hsl(var(--muted-foreground))' }}>
            <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> İzmir, Türkiye</span>
            <span className="flex items-center gap-1"><Phone className="w-3 h-3" /> 0 (232) 000 00 00</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ThemePreview() {
  const [mode, setMode] = useState('light');
  const [paletteIdx, setPaletteIdx] = useState(0);
  const [hero, setHero] = useState('v1');
  const [selected, setSelected] = useState(null);
  const palette = PALETTES[paletteIdx];

  const selectCtl = 'px-2.5 py-1.5 rounded-lg border border-input bg-background text-xs';

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Sticky controls */}
      <div className="sticky top-0 z-30 border-b border-border bg-background/90 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="font-heading text-lg font-semibold">Tema Önizleme</h1>
            <p className="text-xs text-muted-foreground">16 tasarım teması — renk paleti, hero versiyonu ve açık/koyu modu deneyin.</p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <button onClick={() => setMode(m => m === 'dark' ? 'light' : 'dark')} data-testid="theme-preview-mode-toggle" className={selectCtl}>
              {mode === 'dark' ? 'Koyu ✓' : 'Açık ✓'}
            </button>
            <select value={paletteIdx} onChange={e => setPaletteIdx(Number(e.target.value))} data-testid="theme-preview-palette-select" className={selectCtl}>
              {PALETTES.map((p, i) => <option key={p.name} value={i}>{p.name}</option>)}
            </select>
            <select value={hero} onChange={e => setHero(e.target.value)} data-testid="theme-preview-hero-select" className={selectCtl}>
              {HEROES.map(h => <option key={h.v} value={h.v}>{h.label}</option>)}
            </select>
          </div>
        </div>
        {selected && (
          <div className="max-w-7xl mx-auto px-4 pb-3">
            <div className="text-xs px-3 py-2 rounded-lg bg-[hsl(var(--gold)/0.12)] text-foreground inline-flex items-center gap-2" data-testid="theme-preview-selection">
              Seçilen tema: <strong>{THEMES.find(t => t.id === selected)?.name}</strong> · Renk: <strong>{palette.name}</strong> · Hero: <strong>{HEROES.find(h => h.v === hero)?.label}</strong>
            </div>
          </div>
        )}
      </div>

      {/* Theme grid */}
      <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 xl:grid-cols-2 gap-6">
        {THEMES.map(theme => (
          <ThemeCard key={theme.id} theme={theme} palette={palette} mode={mode} hero={hero} onApply={(t) => setSelected(t.id)} />
        ))}
      </div>
    </div>
  );
}
